import { ExternalContentProviders } from "../constants/ExternalContentProviders.enum";
import { StoreDocumentsHyarchisDto } from "./hyarchisStoreDocument";

export default class CloudItem {
  public source!: string;
  public provider!: ExternalContentProviders;
  public providerName!: string;
  public parentId!: string;
  public folderId!: string;
  public folderPath!: string;
  public fileName!: string;
  public exportName!: string;
  /**
   * 'Files','Folder' or 'Zip' export method
   */
  public exportMethod!: string;
  /**
   * Checklist item id for hyarchis export
   */
  public itemId: number | null = null;
  
  public hyarchisDTO?: StoreDocumentsHyarchisDto | null = null;
}
